import React from 'react';
import Page from 'src/components/Page';
import Table from 'src/components/Table';
import SpecLink from '../../SpecLink';

function BillerPage() {
    return <Page header="Biller">
        <p>
            Using biller codes makes it easy to manage and keep track of payments if you have multiple income streams. You can disable or delete a biller code at any time.
        </p>

        <h2>Payment Rules</h2>
        <p>
            The only API endpoint available for billers is to fetch <SpecLink uriFragment="#operation/Biller_GetPaymentRules">biller payment rules</SpecLink> by biller code.
        </p>
        <Table
            headers={['Payment Rule', 'Description']}
            body={[
                ['Amount limits', 'Minimum and/or maximum limits for transaction amounts.'],
                ['Accepted cards', 'Cards accepted by the biller.'],
                ['Surcharge rules', 'Surcharge rules set for the biller. Surcharges can be a fixed amount and/or a percentage of the transaction. Surcharges can also have minimum and maximum amounts.'],
                ['Accepted payment method providers', 'Klarna and/or ApplePay.'],
            ]}
        />
    </Page>
}

export default BillerPage;
